import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import axios from 'axios';
import { call, select } from 'redux-saga/effects';
import { getConfigKey } from '@wix/da-redux-config/pkg/selectors';
import ddt from '@wix/da-ddt';
import { CANCEL } from 'redux-saga';
export var PapiVersions;
(function(PapiVersions) {
    PapiVersions[PapiVersions["v20181102"] = 20181102] = "v20181102";
    PapiVersions[PapiVersions["v20190117"] = 20190117] = "v20190117";
    PapiVersions[PapiVersions["v20190423"] = 20190423] = "v20190423";
    PapiVersions[PapiVersions["v20191101"] = 20191101] = "v20191101";
    PapiVersions[PapiVersions["v20230710"] = 20230710] = "v20230710";
})(PapiVersions || (PapiVersions = {}));
const LATEST_VERSION = 20230710;
const CANONICAL_XHR_NAPI_ENDPOINT = 'https://www.deviantart.com/_napi/shared_api/';
const LOCAL_XHR_NAPI_ENDPOINT = 'https://www.deviantart.lan/_napi/shared_api/';
const CANONICAL_XHR_PUPPY_ENDPOINT = 'https://www.deviantart.com/_puppy/';
const LOCAL_XHR_PUPPY_ENDPOINT = 'https://www.deviantart.lan/_puppy/';
function getFakeResponse(response) {
    if (process.env.NODE_ENV === 'test') {
        return response;
    }
    return new Promise((resolve)=>{
        setTimeout(()=>resolve(response), 1000);
    });
}
function getApiResponse(options) {
    const cancelTokenSource = axios.CancelToken.source();
    const promise = axios.request(options.enableCancellation ? _object_spread_props(_object_spread({}, options), {
        cancelToken: cancelTokenSource.token
    }) : options).then((response)=>{
        return response.data;
    }).catch((e)=>{
        var _e_response, _e_response1;
        var _e_response_status;
        // This deals with some legacy issues, we used to have node translate 400
        // to 200 because really papi should return user handleable errors as 200
        // but as it doesn't we have to do some special handling. Logic is if its
        // a 500 return false, otherwise return the error so it can be used by
        // isApiError and displayed to the user. For 500s, we generally do
        // !response before the isApiError check, so this should give us the same
        // execution as before puppy migrations. Maybe in the future we can actually
        // address our error handling once and for all...
        if (((_e_response_status = (_e_response = e.response) === null || _e_response === void 0 ? void 0 : _e_response.status) !== null && _e_response_status !== void 0 ? _e_response_status : 500) >= 500) {
            return false;
        }
        return (_e_response1 = e.response) === null || _e_response1 === void 0 ? void 0 : _e_response1.data;
    });
    // redux saga calls this special prop when it cancel the outer saga E.g. takeLatest
    if (options.enableCancellation) {
        promise[CANCEL] = ()=>cancelTokenSource.cancel();
    }
    return promise;
}
function* configureOptions(options) {
    // CSRF
    const csrf = yield select(getConfigKey, 'csrfToken');
    if (options.method && options.method.toLowerCase() === 'post') {
        if (options.data === undefined) {
            options.data = {};
        }
        options.data['csrf_token'] = csrf;
        // Version
        if (!options.data.da_minor_version) {
            options.data.da_minor_version = LATEST_VERSION;
        }
    } else {
        if (options.params === undefined) {
            options.params = {};
        }
        options.params['csrf_token'] = csrf;
        // Version
        if (!options.params.da_minor_version) {
            options.params.da_minor_version = LATEST_VERSION;
        }
    }
    const withCreds = yield select(getConfigKey, 'withCredentials');
    if (withCreds) {
        options.withCredentials = true;
    }
    return options;
}
function* runFake(fakeResponse, options) {
    // Using node env so we strip for prod bundle sdf sdf sdf
    if (process.env.NODE_ENV !== 'production') {
        if (fakeResponse !== undefined) {
            const doFake = yield select(getConfigKey, 'fakeApiRequests');
            if (doFake) {
                ddt.log('saga', `Faked XHR for: ${options.url}`, options, fakeResponse(options));
                const result = yield call(getFakeResponse, fakeResponse(options));
                return result;
            }
        }
    }
}
export function isApiError(response) {
    return response.error || response.errorCode;
}
/**
 * TODO once everything is ported to puppy, rename this to requestNapi
 * Calls napi, this one you probably don't need, use puppy instead
 */ export function* request(options, fakeResponse) {
    // Routing
    // local dev goes to sharedApiBasePath which hits the express middlewares locally
    // xhr local goes to the VM
    // canonical goes to the xhr-server
    if (options.baseURL === undefined) {
        // Handle prod vs local endpoint routing
        if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
            options.baseURL = yield select(getConfigKey, 'sharedApiBasePath');
        // Local full docker helper
        } else if (window['__XHR_LOCAL__']) {
            options.baseURL = LOCAL_XHR_NAPI_ENDPOINT;
        // Production goes to the xhr server
        } else {
            options.baseURL = CANONICAL_XHR_NAPI_ENDPOINT;
        }
    }
    options = yield call(configureOptions, options);
    const fake = yield call(runFake, fakeResponse, options);
    if (fake) {
        return fake;
    }
    return yield call(getApiResponse, options);
}
/**
 * Calls puppy, this is the one you want in 99% of cases
 */ export function* requestPuppy(options, fakeResponse, papiBase = 'dashared') {
    // Puppy needs the
    if (papiBase) {
        options.url = `${papiBase}/${options.url}`.replace(/\/{2,}/g, '/');
    }
    // Routing
    // local dev hits local nodejs proxy to deal with http -> https
    // vm hits vm
    // canonical hits puppy
    if (options.baseURL === undefined) {
        // Handle prod vs local endpoint routing
        if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
            options.baseURL = `${window.location.origin}/_puppy/`;
        // Local full docker helper
        } else if (window['__XHR_LOCAL__']) {
            options.baseURL = LOCAL_XHR_PUPPY_ENDPOINT;
        // Production goes to the xhr server
        } else {
            options.baseURL = CANONICAL_XHR_PUPPY_ENDPOINT;
        }
    }
    options = yield call(configureOptions, options);
    const fake = yield call(runFake, fakeResponse, options);
    if (fake) {
        return fake;
    }
    return yield call(getApiResponse, options);
}
